module.exports = __webpack_public_path__ + "static/media/ieee_insat_black.b5586eef.png";